<template>
	<div v-if="dataOrder">
		<p class="group-date"><b>{{ itemDate(dataOrder['date']) }}</b></p>
		<!-- <p>{{ dataOrder['data'].length }}</p> -->
		<div v-for="item in dataOrder['data']">
			<div
				class="affair-list-item"
				:class="{ marked: isMarked(item[0]) }"
			>
				<div class="list-item-top">
					<span
						class="w-full"
					>
						{{ $t('order') }} № <b>
							<a
								target="_blank"
								:href="'/ticket/'+item[0].orderId"
								class="break-words hyphens-auto"
							>
								{{ item[0].orderId }}
							</a></b>
					</span>
				</div>
				<div class="list-item-bottom">
					<span
						class="w-full"
					>
						{{ $t('pagesAmount') }}: <b>{{ item[0].pages_number }}</b>
					</span>
				</div>
				<div v-if="$store.state.auth.role === 'manager'"
					class="list-item-bottom">
					<span
						class="w-full"
					>
						{{ $t('author') }}: <b>
							<a
								target="_blank"
								:href="'/authorM/'+item[0].authorId"
								class="break-words hyphens-auto"
							>
								{{ item[0].authorUsername }}
							</a></b>
					</span>
				</div>
				<div 
					class="list-item-bottom">
					<span
						class="w-full"
					>
						{{ $t('dueDate') }}: <b>{{ itemDateCurrent(item[0].date_time) }}</b>
					</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import moment from 'moment';
import date from "@/assets/configs/date.js";

export default {
	name: 'AuthorAffairListItem',
	props: {
		dataOrder: {
		}
	},
	computed: {
	},
	methods: {
		itemDate(txtDate) {
			const dateMoment = moment(txtDate);
			const weekDay = this.$t(date.days[dateMoment.day()]);
			const day = dateMoment.format("DD")
			const month = this.$t(date.months[dateMoment.month()] + "Genitive");
			const year = dateMoment.format("YYYY");
			// return dateMoment.format("DD.MM.YYYY HH:mm");
			return `${weekDay}, ${day} ${month} ${year}`;
		},
		itemDateCurrent(txtDate) {
			const dateMoment = moment(txtDate);
			const weekDay = this.$t(date.days[dateMoment.day()]);
			const day = dateMoment.format("DD")
			const month = this.$t(date.months[dateMoment.month()] + "Genitive");
			const year = dateMoment.format("YYYY");
			return dateMoment.format("DD.MM.YYYY HH:mm");
			// return `${weekDay}, ${day} ${month} ${year}`;
		},
		getTime(datetime) {
			const [date, time] = datetime.split(" ");
			const [h, m] = time.split(":");
			return `${h}:${m}`;
		},
		async changeTaskState (e) {
			setTimeout(() => {
				if (e) {
					this.$store.dispatch('calendar/setTaskCompleted', this.data)
				} else
					this.$store.dispatch('calendar/reopenTask', this.data)
			}, 300);
		},
		deleteTask () {
			this.$store.dispatch('calendar/deleteTask', this.data)
		},
		assignToManager () {
			this.$emit('assignToManager', this.data)
		},
		editTask(){
			this.$emit('editTask', this.data)
		},
		isMarked(item) {
			const taskDate = item.date_time;
			const currentDate = moment(new Date()).format("YYYY-MM-DD");
			return currentDate > taskDate;
		},
	},
	created() {
		// console.log(this.dataOrder['data'][0]);
	}
}
</script>

<style lang="scss">
.group-date {
	padding: 1rem;
}
.row_manager_name_task {
	margin: auto;
	display: flex;
}
.affair-list-item {
	background-color: red;
	padding: 1rem;
	width: 100%;
	display: flex;
	// cursor: pointer;
	flex-direction: column;
	background-color: #f1f1f166;
	border-top: 1px solid #ddd;

	&.marked {
		background-color: #F4A9A9;
	}

	.completed {
		text-decoration: line-through;
	}

	&:last-of-type{
		border-bottom: 1px solid #ddd;
	}

	.list-item-top {
		display: flex;
		flex-grow: 1;

		b {
			flex-grow: 1;
		}

		.controls-wrapper {
			display: flex;
			align-items: center;
			margin-bottom: 8px;
		}

		&__right {
			display: flex;
			justify-content: center;
			align-items: center;
			width: 20px;
			height: 20px;
		}
	}

	.list-item-bottom {
		display: flex;

		.description-wrapper {
			display: flex;
			flex-grow: 1;

			&__text {
				word-break: break-word;
			}

			b {
				margin-right: 1rem;
			}

		}

		.provided-by-admin {
			font-size: 10px;
			width: 15%;
			margin-right: 10px;
		}
	}

	.vs-checkbox {
		background-color: white;
		border-color: #6f6f6f !important;
	}
}
</style>
